import React, { useState } from 'react'
import BlogCard from "./BlogCard"
import data_blogs from "./Blog.data"

const Blog = () => {
    const perPage = 4;
    const [blogs, setBlogs] = useState(data_blogs.slice(0, perPage));

    const [currentPage, setCurrentPage] = useState(1);
    //const [curName, setCurName] = useState('all');
    const pages = [];
    for (var i = 1; i <= (data_blogs.length / perPage); i++) {
        pages.push(i);
    }
    if ((data_blogs.length % perPage) == 1) {
        pages.push(Math.round(data_blogs.length / perPage) + 1)
    }

    const handlePagination = (pageNumber) => {
        setCurrentPage(pageNumber);
        var current = (pageNumber - 1) * perPage;
        var l = data_blogs.length;
        var end = current + perPage;
        if (end > l) {
            end = l;
        }
        var new_array = data_blogs.slice(current, end);
        //setCurrentPage(current / perPage);
        setBlogs(new_array);
    }

    return (
        <div className="card-inner blog animated" id="blog-card">
            <div className="card-wrap">

                <div className="content blog">

                    <div className="title">
                        <span >Blog</span>
                    </div>

                    <div className="row border-line-v">
                        {
                            blogs.map(blog =>
                                <BlogCard key={blog.name} blog={blog} />)
                        }
                    </div>

                    <div className="pager">
                        <nav className="navigation pagination">
                            <div className="nav-links">
                                {
                                    pages.map(i => {
                                        if (i == currentPage) {
                                            return <span className="page-numbers current"> {i} </span>
                                        }
                                        else {
                                            return <i className="page-numbers" href="" onClick={() => handlePagination(i)}> {i} </i>
                                        }
                                    }
                                    )
                                }
                            </div>
                        </nav>
                    </div>

                </div>

            </div>
        </div>

    );
}


export default Blog;